import { Button, Link, Stack, TextField, Typography } from '@mui/material';
import { useForm } from 'app/hooks';
import { Lang, Password } from 'app/shared';
import {} from 'generated/axios';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LoginWrapper } from './Login.styles';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Container } from '@mui/system';
import { LoginRequest, useAuth, useMessage } from 'app/context';
import { ROUTES } from 'app/utils';
import logo_nvm from '../../../assets/logo_nvm.png';

import { useNavigate } from 'react-router-dom';

export const Login = (): ReactElement => {
  const { i18n, t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const { error } = useMessage();

  const navigate = useNavigate();

  const { login } = useAuth();

  const loginFn = (form: LoginRequest) => {
    setLoading(true);
    login(form)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        navigate(ROUTES.me);
      })
      .catch((err: Error) => {
        error({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const { bindTextField, submit } = useForm<LoginRequest>({ onSubmit: loginFn });

  return (
    <Container maxWidth="xs">
      <Stack direction={'row'} alignItems="center" justifyContent={'center'} sx={{ mt: '20px' }}>
        <LoginWrapper>
          <Stack direction={'column'} justifyContent={'center'} alignItems="center" spacing={5}>
            <Stack direction={'column'} alignItems="center" justifyContent={'center'}>
              <Box p={3} display={'flex'} justifyContent={'center'} width={'80%'}>
                <img src={logo_nvm} alt="logo big" style={{ width: '100%' }} />
              </Box>
              <Typography fontWeight={600} fontSize={'20px'} color="secondary.dark">
                {t('login.subTitle')}
              </Typography>
            </Stack>
            <TextField label={t('login.username')} fullWidth {...bindTextField({ field: 'username' })} />
            <Password label={t('login.password')} fullWidth {...bindTextField({ field: 'password' })} />
            <Lang
              label={t('login.lang')}
              sx={{ width: '80%' }}
              size="small"
              fullWidth
              value={i18n.language}
              onChange={(e) => {
                i18n.changeLanguage(e.target.value);
              }}
            />
            <Button
              loadingPosition="end"
              loading={loading}
              variant="contained"
              size="large"
              onClick={submit}
              endIcon={<LoginIcon />}
            >
              {t('actions.login')}
            </Button>
            <Stack direction="column" alignItems={'center'} spacing={1}>
              <Typography fontSize={'16px'}>
                {t('login.forgotPassword')}{' '}
                <strong>
                  <Link onClick={() => navigate(ROUTES.forgotPassword)}>{t('actions.clickHere')}</Link>
                </strong>
              </Typography>
            </Stack>
          </Stack>
        </LoginWrapper>
      </Stack>
    </Container>
  );
};
